var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ellipsis-text"},[_c('tooltip',{staticClass:"ellipsis-text-tooltip",attrs:{"delay":500,"max-width":_vm.maxWidth,"placement":"top","content":_vm.text}},[_c('div',{staticClass:"ellipsis-text-content",style:({ width: _vm.maxWidth })},[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }